import { Button } from "~/hec/components/cta";
import { cn } from "~/lib/utils";

import type { CarouselCtaProps } from "./types";

/**
 * Molecule: the centered primary link button below a product carousel, shared
 * by ProductCarousel and productRecommendations (COM-426).
 */
export function CarouselCta({
  text,
  href,
  className,
  "data-testid": dataTestId,
}: CarouselCtaProps) {
  return (
    <div className={cn("mb-4 mt-6 flex justify-center", className)}>
      <Button
        ctaType="button"
        variant="primary"
        clickFunction="link"
        url={href}
        className="px-12"
        data-testid={dataTestId}
      >
        {text}
      </Button>
    </div>
  );
}
